import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/auth/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { authGuard } from './services/auth.guard';
import { PlatformAdminGuard } from './services/guards/platform-admin.guard';
import { SecurityProfileComponent } from './pages/modules/profile/security-profile.component';

/**
 * Los módulos de producto y de administración se cargan con `import()` dinámico.
 *
 * Antes se declaraban como `loadChildren: () => Promise.resolve(Modulo)` sobre un import estático:
 * el bundler resolvía la referencia en compilación, así que no se generaba ningún chunk y los nueve
 * módulos viajaban en el bundle inicial. Con el import dinámico el bundle inicial baja de 3,58 MB a
 * 1,98 MB (de 680 kB a 390 kB transferidos) y cada módulo se descarga al entrar a su ruta.
 */
const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    component: SecurityProfileComponent,
    canActivate: [authGuard],
  },
  {
    path: 'administration/users',
    canActivate: [authGuard, PlatformAdminGuard],
    loadChildren: () =>
      import('./pages/modules/management/user-management/user-management.module').then((m) => m.UserManagementModule),
  },
  {
    path: 'administration/organizations',
    canActivate: [authGuard, PlatformAdminGuard],
    loadChildren: () =>
      import('./pages/modules/management/organization-management/organization-management.module').then(
        (m) => m.OrganizationManagementModule
      ),
  },
  {
    path: 'home/products/lelfunko',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/modules/lelfunko/lelfunko.module').then((m) => m.LelfunkoModule),
  },
  {
    path: 'home/products/birdattack',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/modules/birdattack/birdattack.module').then((m) => m.BirdattackModule),
  },
  {
    path: 'home/products/airnode',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/modules/airnode/airnode.module').then((m) => m.AirnodeModule),
  },
  {
    path: 'home/products/seppia',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/modules/seppia/seppia.module').then((m) => m.SeppiaModule),
  },
  {
    path: 'home/products/raidar',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/modules/raidar/raidar.module').then((m) => m.RaidarModule),
  },
  {
    path: 'home/products/bin-tracking',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/modules/bin-tracking/bin-tracking.module').then((m) => m.BinTrackingModule),
  },
  {
    path: 'inventory',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/modules/inventory/inventory.module').then((m) => m.InventoryModule),
  },
  {
    path: 'home/inventory',
    redirectTo: '/inventory/products',
    pathMatch: 'full',
  },
  {
    path: 'home/inventory/insumos',
    redirectTo: '/inventory/products',
    pathMatch: 'full',
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' }, // Redirección por defecto
  { path: '**', redirectTo: 'login' }, // Manejo de rutas no encontradas
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
